import React, { Component } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";

import { Button, Card, CardBody, Col, Container, Row} from "reactstrap"
import { Link } from "react-router-dom"
import { BaseUrl } from "../../../helpers/Baseurl"

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';


class EcommerceOrders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      brand_id:"",
      alert_confirm : false,
      success_confirm : false,
      dynamic_title: "",
			dynamic_description: "",

      brands: [],
      breadcrumbItems : [
        { title : "Planmans", link : "/dashboard" },
        { title : "Brands", link : "#" },
    ],
    }

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
      }

    this.handleBrandClicks = this.handleBrandClicks.bind(this)
  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    this.props.history.push('/dashboard')
    toastr.error("Something Went Wrong", "")
  }

  async componentDidMount() {
 
    this.loadData();
 }

 async loadData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/vehicles/brand/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              this.setState({ brands: data  })
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

  handleBrandClicks = id => {   

    const requestOptions = {
      method: 'DELETE',
  
      };
        fetch(`${BaseUrl}/api/vehicles/brand/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                  }
                  else{
                    this.loadData();
                    this.setState({
                      brand_id:"",
                      success_confirm: true,
                      alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Your Brand has been deleted."
                      })
                      
                      
                  }
              }
          )

  }

  render() {

    const { brands } = this.state

    const { SearchBar } = Search

    //pagination customization
    let total_size = brands.length 
    const pageOptions = {
      sizePerPage: 10,
      totalSize: total_size, // replace later with size(Order),
      custom: true,
    }

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    //Columns
    const BrandsColumns = [
      {
        dataField: "id",
        text: "id",
        hidden: true,
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        Style: { float: 'left' },
        formatter: (cellContent, row) => (
          <React.Fragment>
            <Link to="#" onClick={() => this.props.history.push(`/edit-brand/${row.id}`) } className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
            <Link to="#" onClick={() => this.setState({ alert_confirm: true, brand_id:row.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
            </React.Fragment>
        ),
      },
    ]

    return (
      <React.Fragment>
        <div className="page-content">
          
          <Container fluid>
          <Breadcrumbs title="All brands" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      data={brands}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={brands}
                          columns={BrandsColumns}
                          bootstrap4
                          search
                        >
                          
                          {toolkitProps => (
                            <React.Fragment>
                              
                              <Row className="mb-2">
                                <Col sm="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8">
                                  <div className="text-sm-end">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={() => this.props.history.push("/new-brand")}
                                    >
                                      <i className="mdi mdi-plus me-1" />{" "}
                                      Add New Brand
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              <div className="table-responsive">

                                <BootstrapTable
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  headerWrapperClasses={"table-light"}
                                />
                                
                              </div>
                              <div className="pagination pagination-rounded justify-content-end mb-2">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                              {this.state.alert_confirm ? (
                                                    <SweetAlert
                                                    title="Are you sure?"
                                                    warning
                                                    showCancel
                                                    confirmBtnBsStyle="success"
                                                    cancelBtnBsStyle="danger"
                                                    onConfirm={() => this.handleBrandClicks(this.state.brand_id)}
                                                    onCancel={() =>
                                                        this.setState({
                                                            alert_confirm: false,
                                                            brand_id:"",

                                                        })
                                                    }
                                                    >
                                                    You won't be able to revert this!
                                                    </SweetAlert>
                                                ) : null}

                                               {this.state.success_confirm ? (
                                              <SweetAlert
                                              success
                                              title={this.state.dynamic_title}
                                              confirmBtnBsStyle="success"
                                              cancelBtnBsStyle="danger"
                                              onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                                              >
                                                  {this.state.dynamic_description}
                                              </SweetAlert>
                                          )
                                          : null
                                      }
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default EcommerceOrders